/** @typedef {string} EFaxLogStatus */
export const E_FAX_LOG_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const E_FAX_LOG_STATUS_COMPLETE = 'COMPLETE';
export const E_FAX_LOG_STATUS_ERROR = 'ERROR';
/** @enum {EFaxLogStatus} */
export const E_FAX_LOG_STATUS = {
	IN_PROGRESS: E_FAX_LOG_STATUS_IN_PROGRESS,
	COMPLETE: E_FAX_LOG_STATUS_COMPLETE,
	ERROR: E_FAX_LOG_STATUS_ERROR,
};
/** @type {EFaxLogStatus[]} */
export const E_FAX_LOG_STATUSES = Object.values(E_FAX_LOG_STATUS);
export const E_FAX_LOG_STATUS_CLASS = {
	[E_FAX_LOG_STATUS.IN_PROGRESS]: 'default-color',
	[E_FAX_LOG_STATUS.COMPLETE]: 'success-color',
	[E_FAX_LOG_STATUS.ERROR]: 'error-color',
};
export const E_FAX_LOG_STATUS_TAG_CLASS = {
	[E_FAX_LOG_STATUS.IN_PROGRESS]: 'style-default',
	[E_FAX_LOG_STATUS.COMPLETE]: 'style-success',
	[E_FAX_LOG_STATUS.ERROR]: 'style-error',
}
export const E_FAX_LOG_STATUS_ICON = {
	[E_FAX_LOG_STATUS.IN_PROGRESS]: 'hourglass-half',
	[E_FAX_LOG_STATUS.COMPLETE]: 'check-circle-o',
	[E_FAX_LOG_STATUS.ERROR]: 'times-circle-o',
};